import { API_BASE_URL, FAILURE, POST, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";
import moment from "moment";

export async function obtenerListaEmpresaPlataforma(obj, combo = false, tag) {
    try {
        let data = [];
        const { code, body, } = await fetch(
            API_BASE_URL + "/empresa-plataforma/obtener-lista-empresa-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data = body;
            if (combo === false) {
                for (let i = 0; i < data.length; i++) {
                    data[i].fechamodificacion = moment(data[i].fechaModificacion).format("DD/MM/YYYY HH:mm");
                    data[i].habilitadolabel = data[i].habilitado === 1 ? tag("label_yes") : tag("label_no");
                }
            }
            if (combo === true) {
                data = data.map((item) => {
                    return {
                        value: item.id,
                        label: item.nombre,
                    };
                });
            }
        }
        return data;
    } catch (err) {
        console.log("obtenerListaEmpresaPlataforma err");
        console.log(err);
        return [];
    }
}

export async function countNombreEmpresaPlataforma(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa-plataforma/count-nombre-empresa-plataforma",
            API_BASE_URL + "/empresa-plataforma/count-nombre-empresa-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            if (Array.isArray(body) && body.length > 0) {
                data.total = body[0].total;
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("validarNit err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function countUsernameUsuarioPlataforma(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa-plataforma/count-usuario-plataforma",
            API_BASE_URL + "/empresa-plataforma/count-usuario-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            if (Array.isArray(body) && body.length > 0) {
                data.total = body[0].total;
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("validarNit err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function registrarEmpresaPlataforma(obj) {
    try {
        let data = { error: true };
        const { code, message, } = await fetch(
            API_BASE_URL + "/empresa-plataforma/registrar-empresa-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            alert(message);
        }
        return data;
    } catch (err) {
        console.log("registrarEmpresa err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerInfoEmpresa() {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa-plataforma/actualizar-info-empresa-plataforma",
            API_BASE_URL + "/empresa-plataforma/actualizar-info-empresa-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerInfoEmpresa err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarInfoEmpresa(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa-plataforma/actualizar-info-empresa-plataforma",
            API_BASE_URL + "/empresa-plataforma/actualizar-info-empresa-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarInfoEmpresa err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function disableEmpresa(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa-plataforma/disable-empresa-plataforma",
            API_BASE_URL + "/empresa-plataforma/disable-empresa-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("disableEmpresa err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function enableEmpresa(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            // "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa-plataforma/enable-empresa-plataforma",
            API_BASE_URL + "/empresa-plataforma/enable-empresa-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("enablemarca err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function obtenerEventosEmpresaPlataforma(obj) {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            "https://gestiondeflota.boltrack.net/api-gestion-plataforma/empresa-plataforma/eventos-empresa-plataforma",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            for (let i = 0; i < body.length; i++) {
                body[i].fechaprimerreporte = moment(body[i].fechaprimerreporte).format("DD/MM/YYYY HH:mm:ss");
                body[i].fechaultimoreporte = moment(body[i].fechaultimoreporte).format("DD/MM/YYYY HH:mm:ss");
            }
            data.body = body;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerEventosEmpresaPlataforma err");
        console.log(err);
        return { error: true, message: err };
    }
}